import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '../base/configuration/api-service-config';
import { Anomaly } from './anomaly';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAnomaliesAdapterService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getAll(): Observable<Anomaly[]> {
    return this.http
      .get<{
        results: Anomaly[];
      }>(this.config.url + 'anomalies?size=999999&sortBy=DESCRIPTION')
      .pipe(map((res) => res.results));
  }

  create(description: string): Observable<string> {
    return this.http
      .post<{ id: string }>(this.config.url + 'anomalies', { description })
      .pipe(map((a) => a.id));
  }
}
